// Shell.jsx — il FRAME React della shell, auth-gated (§5): monta solo con token,
// si smonta al logout (index.jsx). Composizione R2/R3:
//  - Rail (R2): 6 moduli pari grado — SOLO a flag shell_rail_v2 attiva; a flag
//    spenta resta la resa R1 (rail legacy #amm-rail visibile, body senza classe).
//  - Submenu (R3): colonna del secondo livello — solo se il modulo attivo è
//    registrato con submenu:'shell' e nav[] (host.submenuData), flag dedicata.
//  - MobileBar (R1, estesa R3 con lo sheet sezioni shell).
// L'orchestrazione activate/deactivate vive in host.js (porting verbatim di
// workspace-host, disponibile anche PRIMA del mount React: restore e
// Workspaces.show non aspettano il frame).

import React from 'react';
import { MobileBar } from './MobileBar.jsx';
import { Rail } from './Rail.jsx';
import { Submenu } from './Submenu.jsx';

export function ShellFrame({ host }) {
  const [, setTick] = React.useState(0);
  React.useEffect(() => host.subscribe(() => setTick((t) => t + 1)), [host]);

  const railOn = host.railV2On();
  const sub = railOn ? host.submenuData() : null;

  return (
    <React.Fragment>
      {railOn && <Rail host={host} />}
      {sub && <Submenu host={host} data={sub} />}
      <MobileBar host={host} />
    </React.Fragment>
  );
}
